import { EventViewData } from 'components/eventView/pages/eventData';

export const NlsDays2024Event: EventViewData = {
    eventId: 'nlsdays2024',
    mapId: '53f35471-48b6-4228-b126-1c5128432c82',
    guideId: '639a789f-87f4-46d6-a3db-4a1d4dd005e5',
    programSettings: {
        showAddToCalendar: true,
        programTitle: 'Agenda',
        timezone: 'Europe/Stockholm',
        searchable: true,
        speakersListId: '6296ac77-fa06-4aed-bd27-4dfaaaaa9c1b',
        embedItemBackgroundColor: '#dcdcdc'
    },
    listViewSettings: {
        '718f2183-1b3c-42f7-9053-bca5de716ca7': {
            viewType: 'sections'
        }
    },
    filterSettings: {
        // 'Investors'
        'c6645586-6d55-4965-9efc-a73fac464875': {
            type: 'simple',
            optionIds: []
        },
        // 'Sponsors',
        '718f2183-1b3c-42f7-9053-bca5de716ca7': {
            type: 'simple',
            optionIds: [
                '6e429900-c5e6-494f-b5b6-acc3f0b5eee7',
                '5c5a7cfc-6c22-4c64-860d-07430c45bdf9',
                'cb12a3bc-e225-412f-accb-766fdfd095f4',
                '16de3c86-5cb8-42e6-84b7-6732ae460090',
                '25bdb784-9930-426d-a03f-e0907430b33f',
                'bb56dddc-c22c-45b0-abb3-3d16ed764318',
                '536aaec1-56ad-4f17-bcd3-2bcb94519d29',
                '5f8d60b5-ac9b-4a82-b158-cbe0ef668a03',
                '11489cea-07c2-4f8f-b886-a368a4d4433f',
                'bf042567-310c-47c5-91df-d23dac27060e',
                'bfb3aa5a-c7c9-4f53-a9f1-bbd1f325ebb9',
                'd6437acb-9fec-4106-be43-2fd66257beb0',
                '899199f8-6f23-47ac-9093-43c155cc1dc0',
                '57507d26-12e4-4ae0-8d0c-41558f8b94e0',
                '84cfcf90-d33f-4371-86e2-f2ef0a9ced8e',
                'ba1bd3d5-4552-43ac-aadc-5a8472cb2f1d',
                'febee50c-e50e-45ed-bdbe-21724cc14540',
                '15f263d3-da4b-4a0a-8ba7-9f046775738f',
                'a0c27209-0386-4ed5-8f01-baf73c091705',
                'b42dafc8-33a5-481b-a698-39ecc800946d',
                '863fc715-3980-4c04-9c5b-0d842eb7f612',
                'efa44cc6-28ad-4d53-893b-28f3d131a865',
                '4d4d7b7c-275e-4a0c-96d9-81f1def7cfe5',
                '847af757-5cc3-4bcb-bd73-8a1c5557874f',
                'e84c95df-fa50-4f86-9060-42ead966dc5a',
                '6b13387a-0b0a-423d-b98b-cc7e49424619'
            ]
        },
        // 'Exhibitors',
        '9ff1b2f5-54c6-4257-81ba-b29d5bc8f899': {
            type: 'simple',
            optionIds: [
                '82a624e1-5265-4112-a58c-886385946c88',
                'f8edb328-201d-4e89-a178-0b9407929fed',
                '7d4f9a81-82a7-4474-bd1a-d7cd71400ca7',
                '27909bd2-ca26-4937-a19c-ffe9efe93963',
                '10b6cbb6-5555-44e9-bdb5-cf647b4f7ee0',
                'b756433d-b07d-4f8c-bba7-9f3ddd839a16',
                '6efce9d9-d52b-4356-8c32-26cc62ce31d8',
                'e1e2d37b-8795-482f-9f61-9c3f6d1d3945',
                'cd7d1b2a-f93e-4dce-8178-b40e998d041c',
                '931a437a-5bef-4fa4-9dce-83fd939cb8c6'
            ]
        },
        // Company presentations
        '98e5f7da-a4a6-4675-a4d1-10288e93cca7': {
            type: 'simple',
            optionIds: []
        },
        map: {
            type: 'simple',
            optionIds: []
        }
    },
    mapSettings: {
        standZoom: 0.7
    },
    eventInfo: {
        order: {
            mobile: [
                'home',
                'program',
                '9ff1b2f5-54c6-4257-81ba-b29d5bc8f899',
                'map',
                'information'
            ],
            primes: ['program'],
            normal: [
                '718f2183-1b3c-42f7-9053-bca5de716ca7',
                '9ff1b2f5-54c6-4257-81ba-b29d5bc8f899',
                '6296ac77-fa06-4aed-bd27-4dfaaaaa9c1b',
                '...',
                'information'
            ],
            wide: [
                'home',
                'program',
                '718f2183-1b3c-42f7-9053-bca5de716ca7',
                '9ff1b2f5-54c6-4257-81ba-b29d5bc8f899',
                '6296ac77-fa06-4aed-bd27-4dfaaaaa9c1b',
                '...',
                'information',
                'map'
            ]
        }
    }
};
